export default {
  searchbar: {
    placeholders: [
      "Søk etter en tittel",
      "Søk etter en artist",
      "Søk etter et tempo",
      "Søk etter en dato",
      "Søk etter en lengde",
      "Søk etter en sjanger",
      "Søk etter en platform"
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/misc/TrackSearcher.js